import Emitter from './emitter';
import Cookie from './cookie';
import lego from './lego';
import isMobile from './is-mobile';
export default {
  Emitter,
  Cookie,
  lego,
  isMobile,
};



// WEBPACK FOOTER //
// ./src/components/util.js